import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@fluentui/react-components';
import { SearchBox } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getSearchInputStyles, searchInputTitleStyles } from './style/search-input-style';
import { SEARCH_INPUT_TITLES, SEARCH_INPUT_PLACEHOLDERS } from './constants';

export const SearchInput = (props) => {
  const classes = useDefaultStyles(getSearchInputStyles);
  const i18n = useContext(I18nContext);
  const {
    onSearch,
    onChange,
    type,
    value,
    enabled,
  } = props;

  return (
    <div className={classes.searchInputContainer}>
      <div>
        <Text
          style={searchInputTitleStyles}
        >
          {i18n.getString(SEARCH_INPUT_TITLES[type])}
        </Text>
      </div>
      <SearchBox
        placeholder={i18n.getString(SEARCH_INPUT_PLACEHOLDERS[type])}
        onSearch={onSearch}
        onChange={onChange}
        ariaLabel={i18n.getString(SEARCH_INPUT_PLACEHOLDERS[type])}
        value={value}
        className={classes.searchBox}
        iconProps={{ iconName: 'Search', style: { pointerEvents: 'auto', cursor: 'pointer' }, onClick: onSearch }}
        showIcon
        disabled={!enabled}
      />
    </div>
  );
};

SearchInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
};
